import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';
import { createUseStyles } from 'react-jss';

export interface BrowseInfoThemeProps {
  background: string;
}
const styles: ComponentStylesProps<BrowseInfoThemeProps> = {
  background: ({ background }) => ({
    background: `url(${background}) no-repeat center center fixed`,
    backgroundSize: 'cover',
    paddingTop: '8rem',
  }),
  [breakpoints.sm.down]: {
    background: () => ({
      paddingTop: '5rem',
    }),
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
